<template>
	<div class="pp-header ">
		<section class="header_zhong">
			<article class="flex zhong" @click="goHome" style="cursor: pointer;">
				<img :src="webSet.WebLogo" />
				<p>{{ webSet.OrganizationName }}</p>
			</article>
		</section>
		<section class="header_menu">
			<article class="header_menu_title zhong float">
				<ul>
					<li
						v-for="(item, index) in navigationList"
						:key="index"
						:class="{
							'head-nav-link': $route.fullPath.includes(
								item.Position == 1
									? 'home'
									: item.Position == 2
									? 'evaluationIndex'
									: item.Position == 3
									? 'aiIndex'
									: item.Position == 4
									? 'saasIndex'
									: item.Position == 5
									? 'trainIndex'
									: 'aboutIndex'
							)
						}"
						@click="goNav(item.Url, item.Title, item.Position)"
					>
						<a href="javascript:void(0)">{{ item.Title }}</a>
					</li>
				</ul>

				<div class="flex zhong">
					<img src="../image/san/vip.png" v-if="CardSale" class="vip_div" @click="onVip()" />
					<div class="header_fg zhong" v-if="user.user">
						<figure class="flex zhong" @click="goMyCenter">
							<img :src="user.user.ImgStr || require('../image/p-head.png')" alt="" />
							<figcaption>个人中心</figcaption>
						</figure>
						<span @click="logout">退出</span>
					</div>
					<hgroup v-else>
						<span @click="goLogin">登录</span>
						<span @click="goRegsit">注册</span>
					</hgroup>
				</div>
			</article>
		</section>
	</div>
</template>
<script>
import { mapState } from 'vuex';

// 头部
export default {
	name: 'pp-header',

	data() {
		return {
			isColor: 0,
			navigationList: [],
			webSet: {},
			CardSale: false
		};
	},
	mounted() {
		this.GetNavigation();
		this.GetWebSet();
	},
	computed: {
		...mapState(['user'])
	},
	watch: {
		cardSaleStatus(val) {
			this.GetWebSet();
		}
	},
	created() {},
	methods: {
		onVip() {
			if (this.user.user) {
				this.$router.push('/vip');
			} else {
				this.$router.push('/login');
			}
		},
		// 登出
		logout() {
			var that = this;
			that.$confirm('您确定要退出账号吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					that.$store.dispatch('user/logout');
					that.$util.showOk('登出成功');
					setTimeout(() => {
						that.$router.push('/login');
					}, 1500);
				})
				.catch(() => {});
		},
		// 跳转首页
		goHome() {
			if (this.$route.fullPath !== '/') {
				this.$router.push('/');
			}
		},
		// 登录
		goLogin() {
			this.$router.push('/login');
		},
		// 注册
		goRegsit() {
			this.$router.push('/regsit');
		},
		// 头部跳转
		goNav(route, title, position) {
			if (position < 7) {
				if (this.$route.fullPath === route) {
					return;
				}
				this.$router.push({
					path: route
				});
			} else {
				window.open(route);
			}
		},
		goMyCenter() {
			if (!this.$route.fullPath.includes('my')) {
				this.$router.push('/myIndex');
			}
		},
		// 获取导航栏
		GetNavigation: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetNavigation',
				'GET',
				{},
				function(res) {
					if (res.code === 0) {
						var list = res.data;
						var newList = [];
						for (var i = 0; i < list.length; i++) {
							if (list[i].IsPublish) {
								newList.push(list[i]);
							}
						}
						if (newList.length < list.length) {
							var len = list.length - newList.length;
							for (var j = 0; j < len; j++) {
								newList.push(list[newList.length + j]);
							}
						}
						that.$store.dispatch('shop/setNav', newList);
						that.navigationList = newList;
					}
				},
				function(res) {}
			);
		},
		// 获取网站配置
		GetWebSet: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetWebSet',
				'GET',
				{},
				function(res) {
					if (res.code === 0) {
						that.webSet = res.data;
						that.CardSale = res.data.CardSale;
					}
				},
				function(res) {}
			);
		}
	}
};
</script>
<style lang="scss" scoped>
.header_menu_title ul li.head-nav-link {
	background-color: #06222c;
	position: relative;
}

.vip_div {
	width: 119px;
	height: 34px;
	display: block;
	margin-right: 26px;
	cursor: pointer;
}

.header_menu_title ul li.head-nav-link:hover {
	opacity: 1;
}

.header_menu_title ul li.head-nav-link::after {
	content: '';
	width: 100%;
	height: 2px;
	background-color: #fff;
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 1;
}

.header_fg span::after {
	content: '';
	width: 2px;
	height: 20px;
	background-color: #fff;
	opacity: 0.4;
	position: absolute;
	left: 0;
	top: 50%;
	margin-top: -10px;
	z-index: 1;
}

.header_fg span:hover,
.header_fg figure:hover {
	opacity: 0.7;
}

.header_fg span {
	font-size: 16px;
	position: relative;
	margin-left: 30px;
	padding-left: 30px;
	cursor: pointer;
}

.header_fg {
	overflow: hidden;
	display: flex;
}

.header_menu_title figure img {
	display: block;
	width: 40px;
	height: 40px;
	border-radius: 50px;
	background: url(../image/p-head.png) no-repeat left top;
	background-size: 100% 100%;
}

.header_menu_title figure figcaption {
	font-size: 16px;
	margin-left: 11px;
}

.header_menu_title figure {
	overflow: hidden;
	cursor: pointer;
}

/*header_menu_title*/

.header_menu_title ul li:hover {
	opacity: 0.7;
}

.header_menu_title ul li a {
	display: block;
	font-size: 18px;
	color: #fff;
}

.header_menu_title ul li {
	overflow: hidden;
	float: left;
	margin-left: 10px;
	margin-right: 11px;
	min-width: 4%;
	cursor: pointer;
	text-align: center;
}

.header_menu_title ul {
	overflow: hidden;
	width: 68%;
}

.header_menu_title hgroup span:first-child::after {
	content: '';
	width: 2px;
	height: 20px;
	background-color: #fff;
	position: absolute;
	right: 0;
	top: 50%;
	margin-top: -10px;
	z-index: 1;
}

.header_menu_title hgroup span {
	font-size: 16px;
	padding: 0 25px;
	position: relative;
	cursor: pointer;
}

.header_menu_title hgroup span:hover {
	opacity: 0.7;
}

.header_menu_title hgroup {
	overflow: hidden;
}

.header_menu_title {
	overflow: hidden;
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	color: #fff;
	line-height: 60px;
}

.header_menu {
	overflow: hidden;
	background-color: #333;
}

/* header_menu*/

.header_zhong p {
	font-size: 20px;
	color: #333;
	font-weight: 600;
	margin-left: 0.5em;
}

.header_zhong img {
	display: block;
	width: 40px;
	height: 40px;
	cursor: pointer;
}

.header_zhong {
	overflow: hidden;
	max-width: 1200px;
	margin: 0 auto;
	padding: 10px 0;
}

.pp-header {
	overflow: hidden;
	width: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 2000;
	background-color: #fff;
}
</style>
